import React from "react";
import { Layout, Menu, Button } from "antd";
import {
  DashboardOutlined,
  HomeOutlined,
  ApiOutlined,
  KeyOutlined,
  DatabaseOutlined,
  LogoutOutlined,
  UserOutlined,
  AimOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./AppMenu.css";
import { AuthContext } from "../AuthContext";
import { useContext } from "react";

const { Sider } = Layout;

const AppMenu = ({ username }) => {
  const history = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = React.useState("");
  const { userData } = useContext(AuthContext);
  // Update selected key based on current route
  React.useEffect(() => {
    console.log(userData)
    const path = location.pathname;
    if (path.startsWith("/organization")) {
      setSelectedKey("organization");
    }
    else if (path.startsWith("/users")) {
      setSelectedKey("users");
    } else if (path.startsWith("/provider")) {
      setSelectedKey("provider");
    } else if (path.startsWith("/api-keys")) {
      setSelectedKey("api-keys");
    } else if (path.startsWith("/apikeys")) {
      setSelectedKey("apikeys");
    } else if (path.startsWith("/model")) {
      setSelectedKey("model");
    }
    else if (path.startsWith("/avatar")) {
      setSelectedKey("avatar");
    }
    else {
      setSelectedKey("");
    }
  }, [location.pathname]);

  // Handle menu item click
  const handleClick = (e) => {
    setSelectedKey(e.key);
    history(`/${e.key}`);
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/api/auth/logout`);
    } catch (error) {
      console.error("Logout error:", error);
    }
    localStorage.removeItem("selectedOrg");
    history("/login");
  };

  return (
    <Sider

      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        width: 260,
        minWidth: 240,
        maxWidth: 280,
        flex: "0 0 260px",
        backgroundColor: "#000000",
      }}
    >
      {/* Project Name at the top */}
      <div
        style={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "18px",
          // backgroundColor: "#001529",
        }}
      >
        Canoupus
      </div>

      {/* Middle Menu Section */}
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        onClick={handleClick}
        style={{
          flex: 1, // Ensures the menu items occupy middle section
          backgroundColor: "#2e2c2c",
          color: "white",
        }}
      >
        <Menu.Item key="" icon={<DashboardOutlined />}>
          Dashboard
        </Menu.Item>
        <Menu.Item key="organization" icon={<HomeOutlined />}>
          Organizations
        </Menu.Item>
        <Menu.Item key="users" icon={<UserOutlined />}>
          Users
        </Menu.Item>
        <Menu.Item key="provider" icon={<ApiOutlined />}>
          Providers
        </Menu.Item>
        <Menu.Item key="api-keys" icon={<KeyOutlined />}>
          API Keys
        </Menu.Item>
        {/* <Menu.Item key="apikeys" icon={<KeyOutlined />}>
          Old API Keys
        </Menu.Item> */}
        <Menu.Item key="model" icon={<DatabaseOutlined />}>
          Models
        </Menu.Item>
      </Menu>

      {/* Bottom Section for Username and Logout */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          // backgroundColor: "#001529",
        }}
      >
        <div style={{ color: "white", marginBottom: "10px" }}>
          <UserOutlined /> {userData.name || "Username"}
        </div>
        <Button type="primary" icon={<LogoutOutlined />} onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </Sider>
  );
};

export default AppMenu;
